import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { templateActions } from '../../../store/actions/cms/template/template.action';
import { formActions } from '../../../store/actions/cms/form/form.action';
import InheritIcon from '../../../assets/icons/inheritage_icon.svg';
import { sourceTypes } from '../../../constants/cms/sourceType';
import { pageActions } from '../../../store/actions/cms/page/page.action';

class TemplateSelect extends React.Component {
    handleChange = selectedTemplate => {
        const { dispatch, template, form, cms, page } = this.props;
        const selected = template.templates.find(t => { return t.templateId === selectedTemplate.value });
        if (selected) {
            dispatch(templateActions.get(selected.templateId));
            if (cms.enviroment === sourceTypes.FORM)
                dispatch(formActions.softUpdate({ ...form/* , templateId: selected.templateId, oldTemplateId: form.templateId */ }));
            if (cms.enviroment === sourceTypes.PAGE)
                dispatch(pageActions.softUpdate({ ...page/* , templateId: selected.templateId, oldTemplateId: form.templateId  */ }));
        }
    };
    render() {
        const { templates, template } = this.props.template;
        const list = templates.map(t => { return { value: t.templateId, label: t.name } });
        const dot = (color = '#ccc') => ({
            alignItems: 'center',
            display: 'flex',
            ':before': {
                backgroundColor: color,
                borderRadius: 10,
                content: `url(${InheritIcon})`,
                display: 'block',
                marginRight: 8,
                height: 10,
                width: 10,
            },
        });
        const colourStyles = {
            input: styles => ({ ...styles, ...dot() }),
            placeholder: styles => ({ ...styles, ...dot() }),
            singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
        };
        return (
            (
                <div>
                    {templates && template && <Select
                        classNamePrefix="jirango-select"
                        className="jirango-select"
                        options={list}
                        value={template.name ? { label: template.name, value: template.templateId } : null}
                        onChange={this.handleChange}
                        styles={colourStyles}

                    />}
                </div>

            )
        )
    }
}
function mapStateToProps(state) {
    return {
        template: state.template,
        form: state.form,
        page: state.page,
        cms: state.cms
    };
}

export default connect(mapStateToProps)(TemplateSelect);
